import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import logo from '../../assets/images/site-logo-yellow.png';
import register_img from '../../assets/images/register-img.png';
import { Link, useNavigate } from 'react-router-dom';
import { forgot_password } from "../../actions/auth";
import { useDispatch } from "react-redux";
import { Formik, Field, ErrorMessage } from 'formik';
import { ForgotPasswordSchema } from './commonValidation';

function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const res = await dispatch(forgot_password(values.mobile_no));
      console.log(res);
      // Example: if API returns { status: true, user_id: 123 }
      if (res?.success === 1 && res?.data?.id) {
        navigate('/verify-otp', { state: { user_id: res?.data?.id } });
      }

    } catch (error) {
      console.error("Forgot password error:", error);
      if (error.response && error.response.data) {
        const data = error.response.data;
        setErrorMessage(data.message || data.error || 'Something went wrong.');
      }else {
        setErrorMessage('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
      <section className='login-section'>
        <div className='circle-top-left'></div>
        <div className='circle-bottom-left'></div>
        <div className='pattern-top-center'></div>
        <div className='pattern-top-right'></div>
        <div className='pattern-bottom-right'></div>
        <Container className='relative'>
          <Row className='login-inner v-center ptb-100'>

            <Col xs={12} md={12} lg={6} className='left-block'>
              <div className='login-img-wrapper'>
                <div className='logo-block text-center ptb-30 pt-0'>
                  <img src={logo} alt='' />
                </div>
                <div className='login-imgbox'>
                  <img src={register_img} alt='' />
                </div>
                <div className='glow-box'></div>
              </div>
            </Col>

            <Col xs={12} md={12} lg={6} className='right-block d-flex'>
              <div className='form-wrapper ml-auto mr-auto'>
                <div className='logo-block text-center ptb-30 hide show_mobi_view'>
                  <img src={logo} alt='' />
                </div>
                <h2 className='tl'>Find Your Account</h2>

                <Formik
                    initialValues={{ mobile_no: '' }}
                    validationSchema={ForgotPasswordSchema}
                    onSubmit={handleSubmit}
                >
                  {({ handleSubmit, handleChange, values, errors, touched, isSubmitting }) => (
                      <form onSubmit={handleSubmit} className='form-inner d-flex flex-column w-100'>
                        <div className='input-field full-width'>
                          <label className='label'>Enter Mobile No.</label>
                          <Field
                              type='text'
                              name='mobile_no'
                              placeholder='Enter Mobile No.'
                              inputMode='numeric'
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                              }}
                              className='form-control'
                          />
                          {(errorMessage || (touched.otp && errors.otp)) && (
                              <div className="alert alert-danger mt-3">
                                {errorMessage || errors.otp}
                              </div>
                          )}
                        </div>

                        <div className='input-field full-width form-btnbox mb-0'>
                          <Button
                              className='btn secondary w-100'
                              variant="primary"
                              type="submit"
                              disabled={loading}
                          >
                            {loading ? 'Submitting...' : 'Submit'}
                          </Button>
                        </div>
                      </form>
                  )}
                </Formik>

                <div className='or-devider'><span>OR</span></div>
                <div className='link-box'>
                  <p>You have an account? <Link to='/'>Login to your account</Link></p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
  );
}

export default ForgotPassword;
